module.exports = __webpack_public_path__ + "img/xianmi1kg.d91af909.jpg";